import { useMemo } from 'preact/hooks';

import { ButtonService } from '../elements/button.service';
import { useAppDispatch } from '../store/hooks';
import { ProductFormService } from './product-form.service';

export const useProductFormService = () => {
  const dispatch = useAppDispatch();

  return useMemo(() => {
    const buttonService = new ButtonService();
    return new ProductFormService(dispatch, buttonService);
  }, [dispatch]);
};
